import {slugify} from 'transliteration';

const toUrlSafeString = (text: string) => {
  return slugify(text, {
    trim: true,
    replace: [
      ['.', ''],
      [' - ', '-']
    ]
  });
};

export default toUrlSafeString;
